<template>
  <div class="main">
    <div
      style="height:120px;font-size:40px;font-weight:bold;text-align:center;padding-top:5px;letter-spacing:5px;line-height:120px"
    ></div>
    <div class="home" @click="gohome"></div>
    <div class="chart1" v-if="true">
      <el-row type="flex" style="margin-left:20px;margin-top:20px;">
        <el-col>
          <svgprogress
            type="circle"
            :options="options3"
            value="22"
          ></svgprogress>
          <div>回民区</div>
        </el-col>
        <el-col>
          <svgprogress
            type="circle"
            :options="options3"
            value="22"
          ></svgprogress>
          <div>玉泉区</div>
        </el-col>
        <el-col>
          <svgprogress
            type="circle"
            :options="options3"
            value="22"
          ></svgprogress>
          <div>新城区</div>
        </el-col>
        <el-col>
          <svgprogress
            type="circle"
            :options="options3"
            value="22"
          ></svgprogress>
          <div>赛罕区</div>
        </el-col>
        <el-col>
          <svgprogress
            type="circle"
            :options="options3"
            value="22"
          ></svgprogress>
          <div>土默特左旗</div>
        </el-col>
      </el-row>
      <div class="chart3part2">
        <el-row type="flex">
          <el-col style="margin-left:10px;">
            <svgprogress
              type="circle"
              :options="options3"
              value="22"
            ></svgprogress>
            <div>托克托县</div>
          </el-col>
          <el-col style="margin-left:10px;">
            <svgprogress
              type="circle"
              :options="options3"
              value="22"
            ></svgprogress>
            <div>清水河县</div>
          </el-col>
          <el-col style="margin-left:10px;">
            <svgprogress
              type="circle"
              :options="options3"
              value="22"
            ></svgprogress>
            <div>武川县</div>
          </el-col>
          <el-col style="margin-left:10px;">
            <svgprogress
              type="circle"
              :options="options3"
              value="22"
            ></svgprogress>
            <div>林格尔县</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="chart2" v-if="true">
      <div id="myChart2" style="height:278px;width:100%"></div>
    </div>
    <div class="chart3" v-if="true">
      <div id="myChart3" style="margin-top:5px;padding:5px;height:80px;"></div>
      <el-row style="fontSize:14px;text-align:center;margin-top:5px;">
        <el-col :span="12">符合修复整改要求</el-col>
        <el-col :span="12">部分符合修复整改要求</el-col>
      </el-row>
    </div>
    <div class="chart3-2" v-if="true">
      <div id="myChart32" style="margin-top:5px;height:80px;"></div>
      <el-row style="fontSize:14px;text-align:center;margin-top:5px;">
        <el-col :span="12">不符合修复整改要求</el-col>
        <el-col :span="12">未进行修复整改</el-col>
      </el-row>
    </div>
    <div class="chart4">
      <div id="myChart4" style="height:100%;width:100%"></div>
    </div>
    <div class="chart5" v-if="true">
      <div id="myChart5" style="height:100%;width:100%"></div>
    </div>
    <div class="chart6" v-if="false">
      <div id="myChart6" style="height:100%;width:100%"></div>
    </div>
    <div class="chart7" v-if="false">
      <div id="myChart7" style="height:100%;width:100%"></div>
    </div>
    <div class="chart8" v-if="false">
      <div id="myChart8" style="height:100%;width:100%"></div>
    </div>
    <!-- 案件情况分析左 -->
    <div class="chart01" id="myChart01"></div>
    <!-- 案件情况分析右 -->
    <div class="chart02" id="myChart02"></div>
  </div>
</template>

<script>
import G2World from "./g2world.vue";
import svgprogress from "svg-progress-bar";
import G2 from "@antv/g2";
import DataSet from "@antv/data-set";
export default {
  name: "Index",
  components: {
    G2World,
    svgprogress
  },
  data() {
    return {
      serverData: [],
      options: {
        rectRadius: 8,
        gradientColor: ["rgb(114, 150, 236)", "rgb(83,233, 222)"],
        varyStrokeArray: [30, 25],
        textColor: "rgba(0,0,0,0)",
        pathColors: ["#6387ae", "#0a2e48"]
      },
      options3: {
        pathColors: ["#1b475c", "#49bfe9"],
        radius: 40,
        textColor: "#FFF",
        circleWidth: 5
      }
    };
  },
  props: {},
  mounted: function() {
    this.myChart01();
    this.myChart02();
    //this.myChart1();
    this.myChart2();
    this.myChart3();
    this.myChart32();
    this.myChart4();
    this.myChart5();
    this.myChart6();
    //this.myChart7();
    //this.myChart8();
  },
  methods: {
    gohome() {
      this.$router.push({ path: "/home" });
    },
    // 案件情况分析左
    myChart01() {
      var data = {
        total: 280,
        data: [
          { name: "线索受理数", value: 34 },
          { name: "诉前程序数", value: 68 },
          { name: "监察建议", value: 56 },
          { name: "起诉数", value: 90 }
        ]
      };
      var labelData = [];
      var scale = 64 / data.total;
      var totalNum = data.total * scale;
      var step1 = data.data[0].value * scale;
      var step2 = step1 + data.data[1].value * scale;
      var step3 = step2 + data.data[2].value * scale;
      for (var i = 0; i <= totalNum; i++) {
        switch (true) {
          case i < step1:
            labelData.push({
              value: 1,
              name: data.data[0],
              itemStyle: {
                normal: {
                  color: "#e4475f"
                }
              }
            });
            break;
          case step1 < i && i < step2:
            labelData[i] = {
              value: 1,
              name: data.data[1],
              itemStyle: {
                normal: {
                  color: "#3ed587"
                }
              }
            };
            break;
          case step2 < i && i < step3:
            labelData[i] = {
              value: 1,
              name: data.data[2],
              itemStyle: {
                normal: {
                  color: "#8d6da7"
                }
              }
            };
            break;
          case step3 < i && i < totalNum:
            labelData[i] = {
              value: 1,
              name: data.data[3],
              itemStyle: {
                normal: {
                  color: "#00c4e6"
                }
              }
            };
            break;
        }
      }
      let myChart = this.$echarts.init(document.getElementById("myChart01"));
      myChart.setOption({
        tooltip: {
          show: false,
          position: [0, 0],
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },
        grid: {
          left: 0,
          top: "10%",
          bottom: 0,
          right: 0
        },
        series: [
          {
            type: "pie",
            radius: ["0%", "25%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              }
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#01b8d9"
                  }
                }
              }
            ]
          },
          {
            type: "pie",
            radius: ["30%", "35%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              }
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#01b8d9"
                  }
                }
              }
            ]
          },
          {
            type: "pie",
            radius: ["60%", "90%"],
            // hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              }
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#0f3c55"
                  }
                }
              }
            ]
          },
          {
            type: "pie",
            // hoverAnimation: false,
            // color: ["#FF0000", "#FF7900", "#F1C000", "#0068FF"],
            // 'radius': [55, 80],
            radius: ["60%", "90%"],
            startAngle: 30,
            label: {
              normal: {
                formatter: function(params) {
                  return params.value;
                },
                show: true,
                textStyle: {
                  fontSize: "14",
                  color: "#fff"
                },
                padding: [-20, 0, 0, 0]
              }
            },
            labelLine: {
              show: true,
              normal: {
                lineStyle: {
                  width: 2
                },
                smooth: 0.2,
                length: 10,
                length2: 25
              }
            },
            data: data.data,
            z: 1
          },
          {
            type: "pie",
            // hoverAnimation: false,
            // color: ["#FF0000", "#FF7900", "#F1C000", "#0068FF"],
            // 'radius': [55, 80],
            radius: ["60%", "90%"],
            startAngle: 30,
            label: {
              normal: {
                formatter: function(params) {
                  return params.name;
                },
                show: true,
                textStyle: {
                  fontSize: "14",
                  color: "#fff"
                },
                padding: [20, 0, 0, 0]
              }
            },
            labelLine: {
              show: true,
              normal: {
                lineStyle: {
                  width: 2
                },
                smooth: 0.2,
                length: 10,
                length2: 25
              }
            },
            data: data.data,
            z: 1
          },
          {
            // hoverAnimation: true,
            // 'avoidLabelOverlap': true,
            type: "pie",
            data: labelData,
            startAngle: 30,
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "rgb(41, 60, 85)"
              }
            },
            labelLine: {
              show: false
            },
            radius: [60, 90],
            label: {
              normal: {
                show: false
              }
            },
            z: 2
          }
        ]
      });
    },
    myChart02() {
      let myChart = this.$echarts.init(document.getElementById("myChart02"));
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#57617B"
            }
          }
        },
        // legend: {
        //   icon: "rect",
        //   itemWidth: 14,
        //   itemHeight: 5,
        //   itemGap: 13,
        //   data: ["移动", "电信", "联通"],
        //   right: "4%",
        //   textStyle: {
        //     fontSize: 12,
        //     color: "#292f39"
        //   }
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#6cd2f6"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 11,
                color: "#ffffff"
              },
              interval: 0
            },
            data: [
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
              "九月",
              "十月",
              "十一",
              "十二"
            ]
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "单位/件",
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#6cd2f6"
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color: "#ffffff"
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#57617B"
              }
            }
          }
        ],
        series: [
          {
            name: "移动",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  0,
                  [
                    {
                      offset: 0,
                      color: "rgba(16,97,204, 0.3)"
                    },
                    {
                      offset: 0.8,
                      color: "rgba(17,235,210, 0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "rgba(16,97,204,1)"
                  },
                  {
                    offset: 1,
                    color: "rgba(17,235,210,1)"
                  }
                ])
              },
              emphasis: {
                color: "rgb(0,196,132)",
                borderColor: "rgba(0,196,132,0.2)",
                extraCssText: "box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);",
                borderWidth: 10
              }
            },
            data: [
              2000,
              2500,
              2600,
              2400,
              2300,
              3000,
              3400,
              4800,
              6000,
              8000,
              6500,
              6400
            ]
          },
          {
            name: "电信",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(235,80,133,0.5)"
                    },
                    {
                      offset: 0.8,
                      color: "rgba(255,132,79, 0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "rgba(235,80,133,1)"
                  },
                  {
                    offset: 0.2,
                    color: "rgba(255,132,79,1)"
                  },
                  {
                    offset: 0.4,
                    color: "rgba(235,80,133,1)"
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255,132,79,1)"
                  },
                  {
                    offset: 1,
                    color: "rgba(235,80,133,1)"
                  }
                ])
              },
              emphasis: {
                color: "rgb(99,250,235)",
                borderColor: "rgba(99,250,235,0.2)",
                extraCssText: "box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);",
                borderWidth: 10
              }
            },
            data: [
              3200,
              3300,
              3400,
              4000,
              6000,
              8000,
              6500,
              6000,
              5200,
              3600,
              5800,
              5600,
              4900
            ]
          },
          {
            name: "联通",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  0,
                  [
                    {
                      offset: 0,
                      color: "rgba(124,185,221, 0.3)"
                    },
                    {
                      offset: 0.8,
                      color: "rgba(124,185,221, 0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "rgba(124,185,221,1)"
                  },
                  {
                    offset: 1,
                    color: "rgba(124,185,221,1)"
                  }
                ])
              },
              emphasis: {
                color: "rgb(0,196,132)",
                borderColor: "rgba(0,196,132,0.2)",
                extraCssText: "box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);",
                borderWidth: 10
              }
            },
            data: [
              4000,
              4500,
              5600,
              8000,
              6300,
              5600,
              6700,
              6800,
              6900,
              8000,
              4700,
              4800
            ]
          }
        ]
      });
    },
    myChart1() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart1"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案情情况分析",
          top: 20,
          textStyle: {
            fontSize: "18"
          }
        },
        color: [
          "#00dc9b",
          "#0566d4",
          "#dbff0d",
          "#97adfc",
          "#0bca25",
          "#749f83",
          "#ca8622",
          "#bda29a",
          "#6e7074",
          "#546570",
          "#c4ccd3"
        ],
        legend: {
          bottom: 20,
          left: 0,
          type: "scroll"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        textStyle: {
          fontSize: "10",
          fontFamily: "bold"
        },
        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1]
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            data: [
              { value: 335, name: "国有土地使用权" },
              { value: 310, name: "国有财产保护" },
              { value: 274, name: "生态资源与环境保护" },
              { value: 235, name: "食品与药品安全" },
              { value: 400, name: "英烈保护" }
            ],
            roseType: "radius",
            labelLine: {
              normal: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.3)"
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            },
            label: {
              normal: {
                show: true,
                fontSize: 12,
                formatter: "{d}%"
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    },

    myChart2() {
      let myChart = this.$echarts.init(document.getElementById("myChart2"));
      let option = {
        color: ["#c3d4cf", "#80dcc1", "#56c7f2"],
        grid: {
          top: "10%",
          bottom: "10%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "回民区",
            "玉泉区",
            "新城区",
            "赛罕区",
            "托克托县",
            "清水河县",
            "武川县",
            "林格尔县",
            "土默特左旗"
          ],
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          }
        },
        series: [
          {
            data: [40, 58, 38, 25, 90, 30, 70, 50, 40],
            type: "line",
            areaStyle: {},
            smooth: true
          },
          {
            data: [50, 68, 28, 15, 80, 40, 60, 40, 30],
            type: "line",
            areaStyle: {},
            smooth: true
          },
          {
            data: [70, 48, 28, 35, 80, 50, 80, 60, 35],
            type: "line",
            areaStyle: {},
            smooth: true
          }
        ]
      };
      myChart.setOption(option);
    },
    myChart3() {
      var data = [
        {
          gender: "male",
          path:
            "M381.759 0h292l-.64 295.328-100.127-100.096-94.368 94.368C499.808 326.848 512 369.824 512 415.712c0 141.376-114.56 256-256 256-141.376 0-256-114.624-256-256s114.624-256 256-256c48.8 0 94.272 13.92 133.12 37.632l93.376-94.592L381.76 0zM128.032 415.744c0 70.688 57.312 128 128 128s128-57.312 128-128-57.312-128-128-128-128 57.312-128 128z",
          value: 50
        },
        {
          gender: "middle",
          path:
            "M381.759 0h292l-.64 295.328-100.127-100.096-94.368 94.368C499.808 326.848 512 369.824 512 415.712c0 141.376-114.56 256-256 256-141.376 0-256-114.624-256-256s114.624-256 256-256c48.8 0 94.272 13.92 133.12 37.632l93.376-94.592L381.76 0zM128.032 415.744c0 70.688 57.312 128 128 128s128-57.312 128-128-57.312-128-128-128-128 57.312-128 128z",
          value: 25
        }
      ];

      var chart = new G2.Chart({
        container: "myChart3",
        forceFit: true,
        height: 70,
        padding: 0
      });
      chart.source(data, {
        value: {
          min: 0,
          max: 100
        }
      });
      chart.legend(false);
      chart.axis(false);
      chart
        .interval()
        .position("gender*value")
        .color("gender", ["#68abff"])
        // .shape('path', path => [ 'liquid-fill-path', path ])
        .shape("liquid-fill-gauge")
        .style({
          lineWidth: 3,
          opacity: 0.75
        });

      data.forEach(function(row) {
        chart.guide().text({
          top: true,
          position: {
            gender: row.gender,
            value: 50
          },
          content: row.value + "%",
          style: {
            opacity: 0.75,
            fontSize: 36,
            textAlign: "center",
            fill: "#FFF"
          }
        });
      });

      chart.render();
    },
    myChart32() {
      var data = [
        {
          gender: "male",
          path:
            "M381.759 0h292l-.64 295.328-100.127-100.096-94.368 94.368C499.808 326.848 512 369.824 512 415.712c0 141.376-114.56 256-256 256-141.376 0-256-114.624-256-256s114.624-256 256-256c48.8 0 94.272 13.92 133.12 37.632l93.376-94.592L381.76 0zM128.032 415.744c0 70.688 57.312 128 128 128s128-57.312 128-128-57.312-128-128-128-128 57.312-128 128z",
          value: 50
        },
        {
          gender: "middle",
          path:
            "M381.759 0h292l-.64 295.328-100.127-100.096-94.368 94.368C499.808 326.848 512 369.824 512 415.712c0 141.376-114.56 256-256 256-141.376 0-256-114.624-256-256s114.624-256 256-256c48.8 0 94.272 13.92 133.12 37.632l93.376-94.592L381.76 0zM128.032 415.744c0 70.688 57.312 128 128 128s128-57.312 128-128-57.312-128-128-128-128 57.312-128 128z",
          value: 25
        }
      ];

      var chart = new G2.Chart({
        container: "myChart32",
        forceFit: true,
        height: 70,
        padding: 0
      });
      chart.source(data, {
        value: {
          min: 0,
          max: 100
        }
      });
      chart.legend(false);
      chart.axis(false);
      chart
        .interval()
        .position("gender*value")
        .color("gender", ["#68abff"])
        // .shape('path', path => [ 'liquid-fill-path', path ])
        .shape("liquid-fill-gauge")
        .style({
          lineWidth: 3,
          opacity: 0.75
        });

      data.forEach(function(row) {
        chart.guide().text({
          top: true,
          position: {
            gender: row.gender,
            value: 50
          },
          content: row.value + "%",
          style: {
            opacity: 0.75,
            fontSize: 36,
            textAlign: "center",
            fill: "#FFF"
          }
        });
      });

      chart.render();
    },
    myChart7() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart7"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案件统计",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          data: ["民事公益诉讼", "行政公益诉讼"],
          textStyle: {
            fontSize: 12
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                fontSize: 12,
                formatter: "{b}\n{d}%"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "16",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "民事公益诉讼" },
              { value: 310, name: "行政公益诉讼" }
            ]
          }
        ]
      });
    },
    myChart5() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart5"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#7dc7df", "#5486a3", "#7c93c1", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "回民区",
              "玉泉区",
              "新城区",
              "赛罕区",
              "托克托县",
              "清水河县",
              "武川县",
              "林格尔县",
              "土默特左旗"
            ],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            barWidth: 20,
            itemStyle: {
              barBorderRadius: 5
            },
            data: [65, 98, 95, 38, 65, 62, 95, 60, 45]
          },
          {
            data: [30, 40, 30, 35, 50, 30, 70, 100, 90],
            type: "line",
            areaStyle: {},
            smooth: true
          },
          {
            data: [50, 20, 60, 55, 95, 65, 55, 30, 70],
            type: "line",
            areaStyle: {},
            smooth: true
          }
        ]
      });
    },
    myChart6() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart6"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fdddb", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "文\n书\n鉴\n定",
              "痕\n迹\n鉴\n定",
              "声\n像\n资\n料",
              "环\n境\n损\n害",
              "司\n法\n会\n计",
              "计\n算\n机\n鉴\n定",
              "建\n筑\n工\n程",
              "知\n识\n产\n权",
              "产\n品\n质\n量",
              "化\n工\n类",
              "资\n产\n评\n估",
              "农\n业\n类",
              "水\n产\n类",
              "林\n业\n类",
              "矿\n产\n类",
              "其\n他"
            ],
            splitNumber: 1,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 10
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [
              4100,
              6100,
              8100,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500
            ]
          }
        ]
      });
    },
    myChart4() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart4"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fa3af", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: ["2016", "2017", "2018", "2019"],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [4100, 6100, 8100, 7500]
          },
          {
            name: "国有土地使用权出让",
            type: "bar",
            data: [8000, 4500, 4600, 3800]
          },
          {
            name: "生态资源",
            type: "bar",
            data: [6300, 6400, 7800, 6200]
          },
          {
            name: "国有财产",
            type: "bar",
            data: [3800, 4100, 4200, 2500]
          },
          {
            name: "英烈权益",
            type: "bar",
            data: [4500, 3000, 4300, 5500]
          }
        ]
      });
    },
    myChart8() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart8"),
        "dark"
      );
      let that = this;
      var size = [16, 40, 12, 13, 55, 18, 30, 50];

      const file = "/static/neimenggu.json";
      that.$axios.get(file).then(response => {
        this.$echarts.registerMap("neimenggu", response.data);
        myChart.setOption({
          backgroundColor: "",
          title: {
            text: "",
            textStyle: {
              fontSize: 16
            }
          },
          geo3D: {
            map: "neimenggu",
            height: 511,
            width: 690,
            label: {
              show: true,
              emphasis: {
                show: true
              },
              textStyle: {
                color: "#000",
                fontSize: 14,
                backgroundColor: "rgba(0,23,11,0)"
              }
            },
            viewControl: {
              zoomSensitivity: 0,
              panSensitivity: 0,
              rotateSensitivity: 0,
              alpha: 50,
              orthographicSize: 300
            },
            //shading :"color",
            emphasis: {
              //当鼠标放上去  地区区域是否显示名称
              label: {
                show: true,
                textStyle: {
                  color: "#000",
                  fontSize: 1,
                  backgroundColor: "rgba(0,23,11,0)"
                }
              }
            },
            roam: false, //是否允许缩放
            scaleLimit: {
              min: 1 //定义滚轮缩放的极限控制
            },
            itemStyle: {
              color: "#8df6ff",
              //areaColor: "rgb(141,245,255)",
              opacity: 1,
              borderWidth: 1,
              //borderColor: "rgb(62,215,213)"
              borderColor: "#759fd2"
            }
          },
          light: {
            //光照阴影
            main: {
              color: "#fff", //光照颜色
              intensity: 1.2, //光照强度
              //shadowQuality: 'high', //阴影亮度
              shadow: false, //是否显示阴影
              alpha: 55,
              beta: 10
            }
          },
          series: []
        });
      });
    }
  }
};
</script>

<style scoped>
@import url("../assets/css3d/htmleaf-demo.css");
@import url("../assets/css3d/normalize.css");

.main {
  background: url("../assets/hhht2.png") no-repeat;
  background-size: 100%;
  width: 2880px;
  height: 1080px;
  color: #ffffff;
  z-index: -1;
}

.border {
  background: url("../assets/border3.png") no-repeat;
  background-size: 100% 300px;
  width: 100%;
  height: 300px;
  padding: 5px 5px;
}

.diqiu {
  background: url("../assets/diqiu.png") no-repeat;
  background-size: 334px 263px;
  background-position: center;
  width: 100%;
  height: 263px;
  padding: 5px 5px;
}
.title {
  font-size: 50px;
}

.myChart {
  /* border: #ffffff 2px dashed; */
  width: 96%;
  padding: 5px 30px;
}

.border img {
  width: 120px;
  margin-left: 10px;
}

.box-title {
  text-align: left;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 40px;
}

.group {
  background: url("../assets/img_product/group.png") no-repeat;
  width: 450px;
  height: 275px;
  padding-left: 20px;
  margin-left: 50px;
}

.groupnumber {
  color: #75eaff;
}

.groupcontent {
  color: #bccad4;
}

.home {
  background: url("../assets/home.png") no-repeat;
  position: absolute;
  left: 147px;
  top: 44px;
  width: 120px;
  height: 96px;
  cursor: pointer;
  z-index: 1;
}

.chart1 {
  position: absolute;
  left: 82px;
  top: 723px;
  width: 466px;
  height: 283px;
  border: 0px solid #ffffff;
}

.chart2 {
  position: absolute;
  left: 551px;
  top: 724px;
  width: 548px;
  height: 278px;
  border: 0px solid #ffffff;
}

.chart3 {
  position: absolute;
  left: 2501px;
  top: 133px;
  width: 312px;
  height: 109px;
  border: 0px solid #ffffff;
}

.chart3-2 {
  position: absolute;
  left: 2501px;
  top: 242px;
  width: 312px;
  height: 109px;
  border: 0px solid #ffffff;
}

.chart4 {
  position: absolute;
  left: 1810px;
  top: 407px;
  width: 831px;
  height: 259px;
}

.chart5 {
  position: absolute;
  left: 1808px;
  top: 748px;
  width: 1001px;
  height: 258px;
  border: 0px solid #ffffff;
}

.chart6 {
  position: absolute;
  left: 1923px;
  top: 497px;
  width: 543px;
  height: 195px;
  border: 0px solid #ffffff;
}

.chart7 {
  position: absolute;
  left: 2398px;
  top: 806px;
  width: 165px;
  height: 208px;
  border: 0px solid #ffffff;
}

.chart8 {
  position: absolute;
  left: 2603px;
  top: 812px;
  width: 138px;
  height: 188px;
  border: 0px solid #ffffff;
}

.chart3part2 {
  position: absolute;
  left: 50px;
  top: 140px;
}
.chart01 {
  position: absolute;
  width: 340px;
  height: 240px;
  left: 420px;
  top: 420px;
  /* background-color: aqua; */
}
.chart02 {
  position: absolute;
  width: 340px;
  height: 200px;
  left: 760px;
  top: 450px;
  /* background-color: #75eaff; */
}
</style>
